import React, { useState } from 'react';
import { motion } from 'motion/react';
import { STAR_COLORS } from '../../types';

export const Stars = () => {
  const [stars] = useState(() =>
    Array.from({ length: 120 }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: Math.random() * 2 + 0.5,
      duration: `${Math.random() * 3 + 2}s`,
      delay: `-${Math.random() * 5}s`,
      opacity: Math.random() * 0.7 + 0.3,
      color: STAR_COLORS[Math.floor(Math.random() * STAR_COLORS.length)],
    }))
  );

  return (
    <div className="stars-container">
      {stars.map((star) => (
        <div
          key={star.id}
          className="star"
          style={{
            left: `${star.x}%`,
            top: `${star.y}%`,
            width: `${star.size}px`,
            height: `${star.size}px`,
            backgroundColor: star.color,
            boxShadow: `0 0 ${star.size * 2}px ${star.color}`,
            '--duration': star.duration,
            '--delay': star.delay,
            '--opacity': star.opacity,
          } as React.CSSProperties}
        />
      ))}
    </div>
  );
};

export const Petals = () => {
  const [petals] = useState(() =>
    Array.from({ length: 25 }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: -10,
      size: Math.random() * 12 + 8,
      duration: Math.random() * 15 + 15,
      delay: Math.random() * 15,
    }))
  );

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden z-0">
      {petals.map((petal) => (
        <motion.div
          key={petal.id}
          initial={{ x: `${petal.x}%`, y: '-10%', rotate: 0, opacity: 0 }}
          animate={{
            y: '110%',
            x: [`${petal.x}%`, `${petal.x + 10}%`, `${petal.x - 5}%`, `${petal.x}%`],
            rotate: [0, 180, 360],
            opacity: [0, 0.4, 0.4, 0],
          }}
          transition={{
            duration: petal.duration,
            delay: petal.delay,
            repeat: Infinity,
            ease: 'linear',
          }}
          className="absolute"
        >
          <div
            className="bg-pink-100/30 rounded-full blur-[1px]"
            style={{
              width: petal.size,
              height: petal.size * 0.6,
              borderRadius: '80% 20% 80% 20%',
              transform: 'rotate(-45deg)',
            }}
          />
        </motion.div>
      ))}
    </div>
  );
};
